import * as React from 'react';
import { Grid, GridColumn as Column, GridCellProps, GridToolbar } from '@progress/kendo-react-grid';
import { ProductAttribute, /*ProductAttributeView, ProductAttributeViewValidationSchema*/ } from '../../models/ProductAttribute';
import { Row, Col, Button } from 'reactstrap';
import * as ArrayUtils from "typescript-array-utils";
import CodeList from './CodeList';
import { Formik, FieldArray, FieldArrayRenderProps, FormikContext } from 'formik';
import { CodeValidationSchema } from '../../models/Code';
import { TableCommandCell } from './TableCommandCell';
import * as shortid from 'shortid';
import { DragCell } from '../controls/GridUtils';
import * as yup from 'yup';
import ProductAttributeService from '../../services/ProductAttributeService';
import { IGridRowModel } from './Utils';
import * as GridColumnEditors from './GridColumnEditors';

type Props = {
    fullProductName: string;
    productId: string;
};

class ProductAttributeViewGridModel extends ProductAttribute implements IGridRowModel {
    _id: string; // client side generated
    inEdit: boolean;
    expanded: boolean;
    isSaving: boolean;

    public static Build(data: ProductAttribute): ProductAttributeViewGridModel {

        const result: ProductAttributeViewGridModel = {
            ...data,
            expanded: false,
            inEdit: false,
            isSaving: false,
            _id: shortid.generate()
        };

        return result;
    }
}

type ProductAttributeListState = {
    gridData: IGridRowModel[];
    activeItem: IGridRowModel;
    selectedItem: IGridRowModel;
    
    //showModal: boolean;
    isLoading: boolean;
    isResetingOrder: boolean;
}

const ProductAttributeListValidationSchema = yup.object().shape({
    items: yup.array().of(CodeValidationSchema)
});

class ProductAttributeList extends React.Component<Props, ProductAttributeListState>
{
    processModelForGrid = (data: ProductAttribute[]) => {
        return (data || []).map((x) => ProductAttributeViewGridModel.Build(x)).sort((a, b) => a.SortOrder - b.SortOrder);
    }

    constructor(props: Readonly<Props>) {
        super(props);


        this.state = {
            gridData: [],
            activeItem: undefined,
            selectedItem: undefined,
            //editedItem: new ProductAttribute(),
            //editedItem: undefined,
            //showModal: false,
            isLoading: false,
            isResetingOrder: false
        }
    }

    componentDidMount() {

        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.productId !== prevProps.productId)
            this.loadData();
    }

    loadData = () => {
        this.setState({ isLoading: true, gridData: [] }, async () => {

            var result = await ProductAttributeService.listByProductId(this.props.productId);

            if (!result.hasErrors) {
                this.setState({
                    gridData: this.processModelForGrid(result.value),
                    isLoading: false
                })
            }

        });
    }

    resetOrder = () => {
        this.setState({
            isResetingOrder: true
        }, async () => {
                var restult = await ProductAttributeService.resetOrderByProductId(this.props.productId);

                this.setState({ isResetingOrder: false });
                this.loadData();
        })
    }

    onCodeListChange = (item: IGridRowModel) => {

        let currentAttributeIndex = this.state.gridData.findIndex(x => x._id === item._id);
        let refreshedAttributes = ArrayUtils.replace(this.state.gridData, currentAttributeIndex, item);
        this.setState({
            gridData: refreshedAttributes,
            selectedItem: item
        })
    }

    MyFormGrid = (props: FormGridProps) => <FormGrid {...props}

        onDataSaved={(gridData: IGridRowModel[]) => { this.setState({ gridData }) }}

        getOriginalItem={(item: IGridRowModel) => this.state.gridData.find((x) => x._id === item._id)}
        resetOrder={this.resetOrder}
        isResetingOrder={this.state.isResetingOrder}
    />

    

    render() {

        return <React.Fragment>
            <Row>
                <Col>
                    <h4 className="mt-4">{this.props.fullProductName} Attributes</h4>
                    
                    <Formik
                        enableReinitialize={true}
                        initialValues={{ items: this.state.gridData }}
                        validationSchema={ProductAttributeListValidationSchema}
                        onSubmit={(values) => {
                            console.log('formik submit', values);
                        }}
                    >

                        {({ values, dirty, submitForm, setFieldValue, resetForm }) => {
                            return <React.Fragment>
                                <FieldArray name="items"
                                    component={this.MyFormGrid}
                                />                                                                
                            </React.Fragment>

                        }}
                    </Formik>

                </Col>
            </Row>
        </React.Fragment>;
    }
};

type FormGridProps = FieldArrayRenderProps & {
    //onSaveRequest: (item: any, gridData: any[]) => void;
    getOriginalItem: (item: IGridRowModel) => IGridRowModel;
    onDataSaved: (gridData: IGridRowModel[]) => void;
    resetOrder: () => void;
    isResetingOrder: boolean;
};

type FormGridState = {
    activeItem: IGridRowModel;
    selectedItem: IGridRowModel;
    editedItem: ProductAttribute;
}

class FormGrid extends React.Component<FormGridProps, FormGridState>{

    static contextType = FormikContext;
    context!: React.ContextType<typeof FormikContext>;


    editField = "inEdit";
    CommandCell;

    constructor(props) {
        super(props);

        this.state = {
            activeItem: undefined,
            selectedItem: undefined,
            editedItem: undefined
        }

        this.CommandCell = TableCommandCell({
            edit: (dataItem: IGridRowModel) => {
                let index = this.getDataSource().findIndex(p => (p._id === dataItem._id));
                dataItem.inEdit = true;
                this.props.replace(index, dataItem);
            },
            editModal: null,
            /*editModal: (dataItem: ProductAttribute) => {
                //  this.props.editProductAttribute(dataItem);

                ProductAttribute.mapToFieldUsedFor(dataItem);

                this.setState({
                    editedItem: dataItem,
                });
            },*/
            remove: null, //() => { },//this.remove,
            add: (dataItem: IGridRowModel) => {
                /*let index = (this.props.value as IGridRowModel[]).findIndex(p => (p._id === dataItem._id));

                dataItem.inEdit = false;

                this.props.onReplace({ value: dataItem, index });*/
            },//this.add,
            discard: () => { /*this.context.formCtx.onFormReset()*/ }, //this.discard,
            update: (dataItem: ProductAttribute) => {
                this.saveItem(dataItem);
            },
            cancel: (dataItem: IGridRowModel) => {
                var originalItem = this.props.getOriginalItem(dataItem);
                let index = this.getDataSource().findIndex(p => (p._id === dataItem._id));
                originalItem.inEdit = false;
                this.props.replace(index, originalItem);

            },
            editField: "inEdit",
            isNew: (dataItem: ProductAttribute) => (dataItem.Id || '').length === 0,
            getStringRepresentation: (dataItem: ProductAttribute) => dataItem.LongDescription
        });
    }

    getDataSource = () => this.props.form.values[this.props.name] as IGridRowModel[];

    // #region drag
    reorder = (dataItem: IGridRowModel) => {

        if (this.state.activeItem && (this.state.activeItem._id === dataItem._id)) {
            return;
        }

        //console.log('reorder', dataItem);

        let reorderedData = this.getDataSource();
        let nextIndex = reorderedData.findIndex(p => (p._id === this.state.activeItem._id));
        let prevIndex = reorderedData.findIndex(p => (p._id === dataItem._id));

        //console.log(`reorder: prev/next: ${prevIndex} > ${nextIndex}`, dataItem);
        this.props.move(prevIndex, nextIndex);
    }

    dragStart = (dataItem: IGridRowModel) => {

        this.setState({
            activeItem: dataItem
        });
    }

    dragEnd = (dataItem: IGridRowModel) => {
        //console.log('dragEnd', dataItem);

        let reorderedData = this.getDataSource();
        let nextIndex = reorderedData.findIndex(p => (p._id === this.state.activeItem._id));
        let prevIndex = reorderedData.findIndex(p => (p._id === dataItem._id));

        if (nextIndex == prevIndex)
            return;

        let newSortOrder = 0;

        if (nextIndex === 0) {
            newSortOrder = (reorderedData[1] as any as ProductAttribute).SortOrder - 100;
        } else {

            if (nextIndex === reorderedData.length - 1)
                newSortOrder = (reorderedData[reorderedData.length - 2] as any as ProductAttribute).SortOrder + 100;
            else {
                let prevSort = (reorderedData[nextIndex - 1] as any as ProductAttribute).SortOrder;
                const nextSort = (reorderedData[nextIndex + 1] as any as ProductAttribute).SortOrder;

                if (prevSort === nextSort) {
                    prevSort = this.findLessThanGreaterThan(prevSort);
                }

                newSortOrder = (nextSort + prevSort) / 2;
            }
        }

        // save here the newSortOrder

        const itemToSave = this.state.activeItem as any as ProductAttribute;

        itemToSave.SortOrder = newSortOrder;
        this.saveItem(itemToSave);
        //this.props.onSaveRequest(itemToSave, this.getDataSource());
    }

    findLessThanGreaterThan = (value: number) => {

        let ds = this.getDataSource();
        let result = (ds[0] as any as ProductAttribute).SortOrder;

        for (var i = 1; i < ds.length; i++) {
            let newValue = (ds[i] as any as ProductAttribute).SortOrder
            if (newValue < value && result < newValue)
                result = newValue;
        }

        if (result === value)
            result -= 100;

        return result;
    }
    // #endregion

    saveItem = (item: ProductAttribute) => {

        return ProductAttributeService.save(item).then((x) => {

            if (!x.hasErrors) {
                let gridData = this.getDataSource();
                let index = (gridData as any as ProductAttribute[]).findIndex(x => x.Id === item.Id);

                let updatedItem = ProductAttributeViewGridModel.Build(x.value);
                (updatedItem as any as IGridRowModel)._id = (item as any as IGridRowModel)._id;
                (updatedItem as any as IGridRowModel).inEdit = false;

                const newGridData = ArrayUtils.replace(gridData, index, updatedItem) as any as IGridRowModel[];

                this.props.onDataSaved(newGridData);
            }

            return x;
        });
    }

    hideEdit = () => {
        this.setState({ editedItem: undefined });
    }

    MyDragCell = (props) => <DragCell<IGridRowModel> {...props}
        reorder={this.reorder}
        dragStart={this.dragStart}
        dragEnd={this.dragEnd}
    />

    CustomBooleanColumn = (props: GridCellProps) => <GridColumnEditors.BooleanColumn {...props} onChange={(e) => {
        //console.log('CustomBooleanColumn:onchange', e.dataItem, e.field, e.value)
        if (e.value == true) {

            let dataItem = e.dataItem as ProductAttribute;
            console.log('CustomBooleanColumn:', dataItem);

            dataItem.AdvancedSearch = false;
            dataItem.ProductDetails = false;
            dataItem.PrimarySearch = false;
            dataItem[e.field] = true;
            switch (e.field) {
                case 'PrimarySearch': break;
                case 'AdvancedSearch': break;
                case 'ProductDetails': break;
                default:
                    console.warn('unprocessed boolean column field: ', e.field);
            }

            let index = (this.getDataSource() as any as IGridRowModel[]).findIndex(p => (p._id === (dataItem as any as IGridRowModel)._id));
            //dataItem.inEdit = true;
            this.props.replace(index, dataItem);
        }

    }} />

    render() {

        return <div>
            <Grid style={{ maxHeight: '1000px' }}
                data={this.props.form.values[this.props.name]}
                detail={CodeList}
                onRowClick={(e) => {
                    this.setState({
                        selectedItem: (e.dataItem as ProductAttributeViewGridModel)
                    });
                }}
                expandField="expanded"
                onExpandChange={(event) => {

                    let dataItem = event.dataItem as IGridRowModel;
                    dataItem.expanded = event.value;

                    var index = (this.getDataSource()).findIndex((x: IGridRowModel) => x._id === dataItem._id);

                    this.props.replace(index, dataItem);
                }}
                editField={this.editField}
            >
                <GridToolbar>
                    <Button onClick={this.props.resetOrder} disabled={this.props.isResetingOrder}>{this.props.isResetingOrder ? 'Reseting..' : 'Reset Order'}</Button>
                </GridToolbar>
                <Column title="" width="40px" cell={this.MyDragCell} />
                {/*<Column field="SortOrder" title="Sort Order" width="100px" editable={false} />*/}
                <Column field="Name" title="Attribute Name" editor="text" editable={false}/>
                <Column field="LongDescription" title="Attribute Name Override" editor="text" cell={GridColumnEditors.TextColumn} />
                <Column field="PrimarySearch" title="Primary Search" editor="boolean" cell={this.CustomBooleanColumn} width="120px" />
                <Column field="AdvancedSearch" title="Advanced Search" editor="boolean" cell={this.CustomBooleanColumn} width="120px" />
                <Column field="ProductDetails" title="Product Details" editor="boolean" cell={this.CustomBooleanColumn} width="120px" />
                <Column field="AttributeType" title="Original Order" editor="text" editable={false} />
                <Column cell={this.CommandCell} width="200px" />
            </Grid>
            
            {/*this.state.editedItem && <Formik
                enableReinitialize={true}
                initialValues={this.state.editedItem as any as ProductAttribute}
                validationSchema={ProductAttributeValidationSchema}                
                onSubmit={(values, actions) => {                    

                    // remap the radio selections
                    ProductAttribute.mapFromFieldUsedFor(values);

                    this.saveItem(values).then(() => {
                        this.setState({ editedItem: undefined });
                    });
                }}
            >

                {(formikInner) => {

                    return <Modal isOpen={this.state.editedItem ? true : false} toggle={this.hideEdit} >
                        <ModalHeader toggle={this.hideEdit}>Product Attribute</ModalHeader>
                        <ModalBody>
                            <ProductAttributeEditorFields values={formikInner.values} />
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={() => { this.setState({ editedItem: undefined }) }}>Cancel</Button>
                            <Button onClick={formikInner.submitForm} disabled={!formikInner.errors} color="primary" >Save</Button>
                        </ModalFooter>
                    </Modal>

                }}
            </Formik>*/}

        </div>
    }
}

export default ProductAttributeList;

